import { render, staticRenderFns } from "./ContractAlertComponent.vue?vue&type=template&id=13c9d249&scoped=true&"
import script from "./ContractAlertComponent.vue?vue&type=script&lang=js&"
export * from "./ContractAlertComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c9d249",
  null
  
)

export default component.exports